import SkeletonThumbnail from './SkeletonThumbnail';
import ThumbnailOverlayed from './ThumbnailOverlayed';
import { useLesson, useLessonProgressTime } from '../../../features/lessons';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_CONSTS } from '../../../constants/TopFilterConstants';
import { LessonCardTimeReadout } from '../LessonCardTimeReadout';
import { useAssetStatus } from '../../../features/userProgress';
import { CardMenuIcon } from '../../../features/cardMenu';
import { useLessonDisplayCategories } from '../../../features/categories';
import { jsx as _jsx } from "react/jsx-runtime";
const LessonThumbnailOverlayed = ({
  lessonId,
  isGhost,
  language,
  headerIcons = /*#__PURE__*/_jsx(CardMenuIcon, {
    language: language,
    lessonId: lessonId,
    use: "on-dark"
  })
}) => {
  const {
    lesson
  } = useLesson(lessonId, language);
  const {
    status
  } = useAssetStatus({
    id: lessonId,
    type: 'LESSON'
  });
  const completed = status === FILTER_CONSTS.STATUSES.COMPLETED;
  const {
    lessonDisplayCategories
  } = useLessonDisplayCategories({
    lessonId
  });
  const {
    remainingTime,
    totalTime
  } = useLessonProgressTime(lessonId);
  if (!lesson) {
    return /*#__PURE__*/_jsx(SkeletonThumbnail, {});
  }
  const {
    lessonType,
    previewThumbnailRectangleUrl
  } = lesson;
  return /*#__PURE__*/_jsx(ThumbnailOverlayed, {
    categories: lessonDisplayCategories || [],
    completed: completed,
    headerIcons: headerIcons,
    isGhost: isGhost,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    remainingTime: remainingTime || undefined,
    thumbnailFooter: !completed && /*#__PURE__*/_jsx(LessonCardTimeReadout, {
      lessonId: lessonId
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.resources.type.${lessonType && lessonType.length ? lessonType[0] : FILTER_CONSTS.LESSON_TYPES.LESSON}`
    }),
    totalTime: totalTime
  });
};
export default LessonThumbnailOverlayed;